



































import { GlobalizeLocaleInfo } from '@openticket/lib-localization';
import {
    Component,
    Prop,
    Vue,
    Watch,
} from 'vue-property-decorator';

@Component({ name: 'OtLocaleFlag' })
export default class OtLocaleFlag extends Vue {

    @Prop({ required: true })
        locale!: GlobalizeLocaleInfo;

    @Prop({ default: true, type: Boolean })
        showLabel!: boolean;

    @Prop({ default: 'medium' })
        size!: 'long' | 'medium' | 'short';

    @Prop({ default: false, type: Boolean })
        alignLeft!: boolean;

    url = '';

    get prefix(): string {
        if (!this.$localization.flagsUrlPrefix) {
            return '';
        }

        return this.$localization.flagsUrlPrefix.replace(/\/*$/, '');
    }

    @Watch('$localization.initialized')
    localizationInitialized(): void {
        this.setFlagUrl();
    }

    @Watch('locale.flagUrl', { immediate: true })
    flagUrlChanged(): void {
        this.setFlagUrl();
    }

    setFlagUrl(): void {
        if (!this.prefix) {
            this.url = '';

            return;
        }

        this.url = `${this.prefix}/${this.locale.flagUrl}`;
    }

    setFallbackUrl(): void {
        if (!this.prefix) {
            this.url = '';

            return;
        }

        this.url = `${this.prefix}/flags/fallback.svg`;
    }

}
